var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "ui-checkbox" }, [
    _c(
      "span",
      { staticClass: "ui-checkbox-input" },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.computedValue,
              expression: "computedValue"
            }
          ],
          attrs: { type: "checkbox", disabled: _vm.disabled },
          domProps: {
            checked: Array.isArray(_vm.computedValue)
              ? _vm._i(_vm.computedValue, null) > -1
              : _vm.computedValue
          },
          on: {
            change: function($event) {
              var $$a = _vm.computedValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.computedValue = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.computedValue = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.computedValue = $$c
              }
            }
          }
        }),
        _c("f-sprite-icon", {
          staticClass: "icon-check",
          attrs: { "icon-link": _vm.$options.icons.IconCheck.id }
        })
      ],
      1
    ),
    _c("span", { staticClass: "ui-checkbox-label" }, [
      _vm.headline
        ? _c("span", {
            staticClass: "ui-checkbox-headline",
            domProps: { textContent: _vm._s(_vm.headline) }
          })
        : _vm._e(),
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }